/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEducationTrainingViewProps } from './education-training';

export default (props: IEducationTrainingViewProps) => {
    const { modelTable, pagination } = props;
    return (
        <div className='row'>
            {modelTable}
            {pagination}
        </div>
    );
};
